import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getStoredReferralCode, clearStoredReferralCode } from "@/components/ReferralBanner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const ref = getStoredReferralCode();
    api.emergentSession(m[1], ref)
      .then((res) => {
        clearStoredReferralCode();
        setUser(res.user);
        // Clean URL hash
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/profile");
      })
      .catch(() => navigate("/auth"));
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <p className="font-serif-display text-3xl italic text-[color:var(--ink-2)]">…</p>
    </div>
  );
}
